import classnames from 'classnames/bind';
import PropTypes from 'prop-types';
import React, { useState } from 'react';

import helpIcon from '@coursera/assets/icons/help.svg';
import { Button } from '@coursera/components';

import styles from './coachmark.module.scss';

const cx = classnames.bind(styles);

function Coachmark({ label, position, showArrow }) {
  const [open, setOpen] = useState(true);

  const css = cx({ coachmarkContainer: true, [`coachmarkContainer-${position}`]: position });
  const arrowCss = cx({ coachmarkBottom: true, [`coachmarkBottom-${position}`]: position });
  return (
    <>
      {open && (
        <div className={css}>
          <div className={styles.closeButton}>
            <Button onClick={() => setOpen(false)} variant="text" aria-label="Close status update">
              <div className={styles.closeIcon} />
            </Button>
          </div>
          <div className={styles.content}>
            <img src={helpIcon} alt="" className={styles.icon} />
            <p role="status">{label}</p>
          </div>
          {showArrow && <div className={arrowCss} />}
        </div>
      )}
    </>
  );
}

Coachmark.propTypes = {
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  position: PropTypes.oneOf(['left', 'right']),
  showArrow: PropTypes.bool,
};

Coachmark.defaultProps = {
  position: 'left',
  showArrow: true,
};

export default Coachmark;
